module.exports = {
    content: {
        host: 'https://api.odyssey-studios.net/',
	token: 'eb78b3ffc9c44656997d39dd08d567cf48bbb3532c76e6e495334ba42d0ddf829edce44317a86f47afaf39d2f024e56e45cab6a1fb0e671dbacb02f67d35061030d75cd8a334a5f981bbef9f8af50db41b8d816201e23553a1b43194296d006cbca10344c6905f0a25c9fa8b1e931725c21ff95db428daf5c0bc04613541aae7'    
    }
}

